import {customBtnBack} from '../components/buttons.js';

(function ($, Drupal) {
    // * -- INI - BOTÓN VOLVER EVENTO -- * \\
    Drupal.behaviors.eventBack = {
        attach: function (context) {
            $(once('eventBack', '.fourvenues-event-ticket-rates-form', context)).each(function () {
                const $form = $(this);
                const $backBtn = $form.find('#edit-back');
                customBtnBack($backBtn, $form);
            });
        },
    };
    // * -- FIN - BOTÓN VOLVER EVENTO -- * \\

    // * -- INI - DIALOG -- * \\
    window.addEventListener('dialog:aftercreate', (e) => {
        const $dialog = $(e.target).parent('.ui-dialog');
        const $element = $(e.target);

        // * -- INI - CLOSE DIALOG * \\
        const $titlebar = $dialog.find('.ui-dialog-titlebar');
        const $closeBtn = $titlebar.find('.ui-dialog-titlebar-close');
        const $content = $dialog.find('.ui-dialog-content');

        $content.prepend($closeBtn);
        // * -- FIN - CLOSE DIALOG * \\

        // * -- INI - VIP TARIFA BTN * \\
        const $tarifas = $dialog.find('.rates-list .js-form-item');

        $tarifas.each(function () {
            tarifaBtn($(this), $dialog);
        })

        Drupal.behaviors.tarifaBtn = {
            attach: function (context) {
                $(once('tarifaBtn', '.rates-list .js-form-item', context)).each(function () {
                    tarifaBtn($(this), $dialog);
                });
            }
        }
        // * -- FIN - VIP TARIFA BTN * \\

        // * -- INI - VIP TARIFA BACK * \\
        Drupal.behaviors.tarifaBack = {
            attach: function (context) {
                $(once('tarifaBack', 'form.fourvenues-event-booking-form', context)).each(function () {
                    const $backBtn = $(this).find('button[data-drupal-selector="edit-back"]');
                    customBtnBack($backBtn, $(this));
                });
            }
        }
        // * -- FIN - VIP TARIFA BACK * \\

        // * -- INI - VIP TARIFA TEXTAREA * \\
        Drupal.behaviors.tarifaTextarea = {
            attach: function (context) {
                $(once('tarifaTextarea', 'form.fourvenues-event-booking-form', context)).each(function () {
                    const $form = $(this);
                    const $textareas = $form.find('textarea');

                    $textareas.each(function () {
                        const $textarea = $(this);
                        $textarea.attr('rows', '1');
                    });
                });
            }
        }
        // * -- FIN - VIP TARIFA TEXTAREA * \\
    });

    // * -- FIN - DIALOG -- * \\

    function tarifaBtn($tarifa, $dialog) {
        const $btn = $('<button>', {
            class: 'btn',
            html: '<i class="fa fa-arrow-right"></i>',
        });

        $tarifa.append($btn);

        $btn.on('click', function (e) {
            e.preventDefault();
            const $input = $tarifa.find('input');
            $input.prop('checked', true);
            $dialog.find('[id^="edit-next--"]').trigger('mousedown');
        });
        $tarifa.on('click', function (e) {
            e.preventDefault();
            const $input = $(this).find('input');
            $input.prop('checked', true);
            $dialog.find('[id^="edit-next--"]').trigger('mousedown');
        });
    }
})(jQuery, Drupal);